import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
	AutoCompleteItem as DropdownAutoCompleteItem,
	Dropdown,
} from "@/components/Dropdown/Dropdown";
import { Information } from "@/components/Information/Information";

import {
	ZohoSyncTriggerWithInherit,
	ZohoListSyncTriggerResponse,
} from "../../../../Company/schema/zoho";

interface ZohoSyncSectionProps {
	isZohoEnabled: boolean;
	isConnected: boolean;
	listSyncTrigger: ZohoListSyncTriggerResponse | undefined;
	selectedZohoSyncTrigger: ZohoSyncTriggerWithInherit | undefined;
	setSelectedZohoSyncTrigger: (trigger: ZohoSyncTriggerWithInherit) => void;
}

export const ZohoSyncSection: FunctionComponent<ZohoSyncSectionProps> = ({
	isZohoEnabled,
	isConnected,
	listSyncTrigger,
	selectedZohoSyncTrigger,
	setSelectedZohoSyncTrigger,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isZohoEnabled || !isConnected) {
		return null;
	}

	return (
		<div className="flex flex-col w-full mt-8">
			<div className="flex flex-col gap-2 w-full mb-4">
				<div className="text-ssm font-medium text-text">
					{tsSettings("zoho.syncTrigger.title")}{" "}
					<Information information={tsSettings("zoho.syncTrigger.description")} />
				</div>
			</div>
			<Dropdown
				data={[
					{
						title: tsSettings("zoho.syncTrigger.INHERIT"),
						id: ZohoSyncTriggerWithInherit.INHERIT,
					},
					{
						title: tsSettings("zoho.syncTrigger.DISABLED"),
						id: ZohoSyncTriggerWithInherit.DISABLED,
					},
					{
						title: tsSettings("zoho.syncTrigger.ON_CAMPAIGN_START"),
						id: ZohoSyncTriggerWithInherit.ON_CAMPAIGN_START,
					},
					{
						title: tsSettings("zoho.syncTrigger.ON_REPLY"),
						id: ZohoSyncTriggerWithInherit.ON_REPLY,
					},
				]}
				defaultValue={
					selectedZohoSyncTrigger
						? {
								id: selectedZohoSyncTrigger,
								title: tsSettings(`zoho.syncTrigger.${selectedZohoSyncTrigger}`),
							}
						: undefined
				}
				floating={true}
				handleSelect={(value: DropdownAutoCompleteItem) => {
					setSelectedZohoSyncTrigger(value.id as ZohoSyncTriggerWithInherit);
				}}
			/>
			{listSyncTrigger?.isInherited && (
				<div className="text-ssm text-text-meta mt-2">
					{tsSettings("zoho.syncTrigger.inheritedFrom")}:{" "}
					{tsSettings(`zoho.syncTrigger.${listSyncTrigger.effectiveTrigger}`)}
				</div>
			)}
		</div>
	);
};
